import * as React from 'react'
import {
  UserRef,
  Widget,
  type WidgetProps,
} from '@packages/surveys-widget-common'
import { fetchApi } from '../fetch-api'
import './root.css'
import type { Models } from '@packages/survey-api'

type Props = {
  userRef: UserRef
  appId: string
} & NonNullable<
  Pick<
    WidgetProps,
    | 'onDidMount'
    | 'onDidClose'
    | 'onHeightChange'
    | 'onConfig'
    | 'onFirstClick'
    | 'onInputFocus'
    | 'onInputBlur'
  >
>

const Root = React.forwardRef(({ appId, userRef, ...rest }: Props, ref) => {
  const queryFn: WidgetProps['surveyQueryFn'] = async ({
    surveyId: _surveyId,
    meta,
  }) => {
    const body: Models['OpenSurveyParams'] = {
      id: _surveyId,
      ...meta,
    }

    return fetchApi<Models['OpenSurveyResponse']>({
      method: 'POST',
      url: `/survey`,
      visitorId: userRef.current.visitorId,
      userId: userRef.current.userId,
      authorization: userRef.current.token,
      appId,
      body: JSON.stringify(body),
    })
  }

  const respondFn: WidgetProps['surveyRespondMutationFn'] = async params => {
    const body: Models['RespondSurveyParams'] = {
      sessionId: params.sessionId,
      answer: params.answer,
    }

    return fetchApi<Models['RespondSurveyResponse']>({
      url: `/survey/response`,
      method: 'POST',
      visitorId: userRef.current.visitorId,
      userId: userRef.current.userId,
      authorization: userRef.current.token,
      body: JSON.stringify(body),
      appId,
    })
  }

  return (
    <Widget
      ref={ref}
      surveyQueryFn={queryFn}
      surveyRespondMutationFn={respondFn}
      {...rest}
    />
  )
})

export default Root
